export const config = {
  screenappBackendBaseUrl: process.env.GATSBY_SCREENAPP_BACKEND_BASE_URL || '',
  screenappFrontendBaseUrl:
    process.env.GATSBY_SCREENAPP_FRONTEND_BASE_URL || 'https://screenapp.io',
  screenappRootUrl: process.env.GATSBY_SCREENAPP_FRONTEND_BASE_URL || '',
};
